
<app-type-resultat-attribution [parentForm]="parentForm"
[typeResultatAttribution]="attribution.resultat"
[uid]="getUid()"></app-type-resultat-attribution>
